<ng-template brtOverlayDirective></ng-template>
